import React, { memo } from "react";
import {
	Modal, ModalBody, ModalFooter,
	Button
} from "reactstrap";

const TimeoutPopup = memo( function TimeoutPopup({
	isOpen, endCurrentSectionAndStartNext
}) {

	const toggle = () => {
		endCurrentSectionAndStartNext();
	};

	return (
		<Modal isOpen={isOpen} size="sm">
			<ModalBody>
				<div>Test stopped due to timeout.</div>
			</ModalBody>

			<ModalFooter>
				<Button
					color="secondary"
					className="modalCloseBtn"
					onClick={endCurrentSectionAndStartNext}
				>OK</Button>
			</ModalFooter>
		</Modal>
	);
});

export default TimeoutPopup;